module.exports = __webpack_public_path__ + "img/smrk.60e84820.png";